import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardHeader,
    Checkbox,
    Container,
    IconButton,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import useContextMenu from 'hooks/useContextMenu';
import { PermissionModel, RoleModel } from 'models/PermissionModel';
import usePermissionModals from 'modules/permissions/hooks/usePermissionModals';
import Api from 'utils/api';


const Permissions = () => {
    const {t} = useTranslation();
    const [roles, setRoles] = useState<RoleModel[]>([]);
    const [permission, setPermissions] = useState<PermissionModel[]>([]);
    const {openAddRoleModal, openAddPermissionModal} = usePermissionModals();

    const {openMenu: openAdd} = useContextMenu(({close}) => [
        <MenuItem
            key="permission"
            onClick={() => {
                openAddPermissionModal().then(load);
                close();
            }}
        >
            {t('permission')}
        </MenuItem>,

        <MenuItem
            key="role"
            onClick={() => {
                openAddRoleModal().then(load);
                close();
            }}
        >
            {t('role')}
        </MenuItem>
    ]);

    const load = () => {
        Promise.all([
            Api.permissions.roles(),
            Api.permissions.permissions(),
        ])
            .then((values) => {
                setRoles(values[0].data.data);
                setPermissions(values[1].data.data);
            });
    };

    useEffect(load, []);

    const change = (rid: number, pid: number, enable: boolean) => {
        enable ? Api.permissions.attach(rid, pid) : Api.permissions.detach(rid, pid)
    };

    return (
        <Container maxWidth={false} sx={{mt: 2}}>
            <Card>
                <CardHeader
                    title={t('permissions')}
                    action={<IconButton
                        aria-label="add permission or role"
                        onClick={openAdd}
                    >
                        <Add/>
                    </IconButton>}
                />
                <TableContainer sx={{height: 'calc(100vh - 148px)'}}>
                    <Table
                        size="small"
                        stickyHeader
                        sx={{
                            'tr:hover': {
                                backgroundColor: 'action.hover',
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                {roles.map(r => <TableCell key={r.id}>{r.name}</TableCell>)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {permission.map(p => (
                                <TableRow key={p.id}>
                                    <TableCell>{p.name}</TableCell>
                                    {roles.map(r => (
                                        <TableCell key={r.id}>
                                            <Checkbox
                                                size="small"
                                                defaultChecked={p.roles.includes(r.id)}
                                                onChange={e => change(r.id, p.id, e.target.checked)}
                                            />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>
        </Container>
    );
};

export default Permissions;
